<script lang="ts">
  import { StoreButton, Button } from '@centerhealth/fe/center-kit';
  import type { CtaModel } from '@centerhealth/fe/center-kit';
  import { SubActions } from '@centerhealth/fe/heap';

  export let title: string,
    subtitle = '',
    cta: CtaModel = {};

  // Sanitize link from "/" and queryParams
  const heapValue = cta?.link?.replace('/', '')?.split('?')[0] as SubActions;
</script>

<section class="mt-7">
  <div class="container gap-4 mx-auto text-center">
    <h2 class="text-center mb-4">
      {title}
    </h2>
    {#if subtitle}
      <p class="text-lg text-gray xl:text-xl">{subtitle}</p>
    {/if}
    <div class="my-6 xxl:my-6">
      <Button
        mobileBlock
        heapAttr={{ action: 'cta', subAction: heapValue }}
        size="xlarge"
        href={cta.link}>{cta.label}</Button
      >
    </div>
    <p class="text-gray mb-5 xl:text-lg">Get the app</p>
    <ul class="sm:inline-flex">
      <li class="mx-1">
        <StoreButton type="app-store" />
      </li>
      <li class="mx-1">
        <StoreButton type="google-play" />
      </li>
    </ul>
  </div>
</section>
